// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/weight-balance-limits.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/weight-balance-limits/weight-balance-limits.js';

mount([g0]);
